import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  gamePause,
  gameResume,
  gameStart,
  gameTick,
  resetGame as resetGameAction,
  softResetGame as softResetGameAction,
} from "../store/game/gameSlice";
import { useAppSelector } from ".";
import { selectGameStatus } from "../store/game/selectors";
import { store } from "../store";
import { saveUserDesign } from "../utils/api";

function useGame() {
  const dispatch = useDispatch();
  const gameStatus = useAppSelector((state) =>
    selectGameStatus(state.game)
  );
  // This will be used to store the interval
  const intervalRef = useRef<number | null>(null);

  const startGame = useCallback(() => {
    // Snapshot the game state and send it to the API
    const currentGameState = store.getState().game;
    saveUserDesign(currentGameState);

    dispatch(gameStart());

    intervalRef.current = window.setInterval(() => {
      dispatch(gameTick(5));
    }, 5000);
  }, [dispatch]);

  const pauseGame = useCallback(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    dispatch(gamePause());
  }, [dispatch]);

  const resumeGame = useCallback(() => {
    dispatch(gameResume());
    intervalRef.current = window.setInterval(() => {
      dispatch(gameTick(5));
    }, 5000);
  }, [dispatch]);

  const resetGame = useCallback(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    dispatch(resetGameAction());
  }, [dispatch]);

  const softResetGame = useCallback(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    dispatch(softResetGameAction());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, []);

  return [gameStatus, startGame, pauseGame, resumeGame, resetGame, softResetGame] as const;
}

export default useGame;
